<template>
    <div id="linkTree"> 
      <div class="crm-header-container">
        <div class="crm-body-container">
          <span class="branch-label"> {{ $t("branch.branch-title") }} </span>
          <span class="restaurant-label"> {{restaurantInfo.restaurantName}}</span>

          <el-input
            :placeholder=" $t('branch.search-branch') "
            v-model="searchBranch"
            clearable
            class="mtb-16"
            >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <div class="text-left">
              <span class="result-search"> {{ $t("branch.result-search") }} {{displayBranchList.length}} {{ displayBranchList.length > 1 ? $t("branch.branches") : $t("branch.branch") }} </span>
          </div>
          <el-table
            :data="displayBranchList" 
            style="width: 100%"
            v-loading="loadingTable"
            :show-header="false"
            ref="table"
            max-height="560"
            >
            <el-table-column prop="branchName" >
              <template slot-scope="scope" >
                <div 
                  class="branch-name flex-column"  
                  @click="scope.row.disabledFlag ? '' : clickSelectBranch(scope.row)"
                  :class="scope.row.disabledFlag ? 'branch-name-disabled' : '' "
                  >
                  <el-row class="flex">
                    <div class=" name-label table-name-text" > {{scope.row.branchName}}</div>
                    <div class="close-branch" v-if="scope.row.disabledFlag" > {{$t("branch.close-branch")}}</div> 
                  </el-row>
                  <div class=" location-label table-name-text" > {{scope.row.address}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="35">
              <template slot-scope="scope">
                <el-button icon="el-icon-arrow-right" circle @click="clickSelectBranch(scope.row)" v-loading.fullscreen.lock="fullscreenLoading" :disabled="scope.row.disabledFlag"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <crm-dialog
        :visible="locationDialog"
        width="70%"
      >
        <div class="flex-column-center">
          <lottie-player
            src="https://lottie.host/b0f0ed30-6c6a-42b0-8dc3-2b7abcf6b8af/54El88kIwa.json"
            background="transparent"
            speed="1"
            style="width: 160px; height: 160px;"
            loop
            autoplay
          ></lottie-player>
          <span class="branch-label">{{ $t("branch.set-location") }}</span>
          <span class="restaurant-label">{{ $t("branch.require-location") }}</span>
        </div>
        <el-button class="btn-crm" :autofocus="false" @click="closeDialog(true)"> {{ $t("branch.current-location") }} </el-button>
        <el-button class="btn-crm-write" @click="locationDialog = false"> {{ $t("branch.user-select-branch") }}</el-button>
      </crm-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import CrmDialog from "@/components/Dialog.vue";
import "@lottiefiles/lottie-player";

export default {
  name: "linkTree",
  props: {
    stepSelectBranch: { default: true, type: Boolean }
  },
  emits: ['redirectFunction'],
  components: {
    CrmDialog,
  },
  data() {
    return {
      locationDialog: true,
      loadingTable : false,
      searchBranch : '',
      branchList : [],
      fullscreenLoading: false,
    };
  },
   
  computed: {
    ...mapGetters({
      restaurantInfo: "restaurant/restaurantInfo",
      restaurantUUID: "restaurant/restaurantUUID",
      branchInfo: "branch/branchInfo",
      branchUUID : "branch/branchUUID",
      branchListGetter: "branch/branchList",
    }),
    displayBranchList() {
      if(this.searchBranch == null) return this.branchList;

      if(this.branchList.length > 0){
        let filtered = this.branchList.filter(data => {
          if (!this.searchBranch || data.branchName.toLowerCase().includes(this.searchBranch.toLowerCase()) )
            return true
        });
        return filtered
      }
      else{
        return []
      }
    },
  },
  async mounted() {
    this.haveBranch = (this.branchUUID != null) && (this.branchUUID != 'null') ? true : false
    this.fetchRestaurantInfo(this.restaurantUUID);
    this.fetchBranchList()
  },
  methods: {
    ...mapActions({
      fetchRestaurantInfo: "restaurant/fetchRestaurantInfo",
      fetchBranchListAction: "branch/fetchBranchList",
      setBranch: "branch/setBranch",
      fetchBranchInfo: "branch/fetchBranchInfo"
    }),
    ...mapMutations({
      closeAuthDialog: "auth/CLOSE_AUTH_DIALOG",
      openAuthDialog: "auth/OPEN_AUTH_DIALOG",
    }),
    async fetchBranchList() {
      this.loadingTable = true;
      await this.fetchBranchListAction()
        .then((res) => {
          this.branchList = res
        })
        .catch((error) => {
          this.branchList = [];
        })
        .finally(() => {
        this.loadingTable = false;
      });

      if(this.branchList.length > 0)
        this.branchList = await this.sortBranchByname(this.branchList)
    },
    async clickSelectBranch(rowSelect){
      await this.setBranch(rowSelect.branchUUID)
      await this.fetchBranchInfo(rowSelect.branchUUID)
      // this.$emit("update-select-branch",false)
      this.fullscreenLoading = true
      this.$emit("redirectFunction");
    },
    closeDialog(currentLocation){
      this.locationDialog = false
      if(currentLocation) this.getLocation()
    },
    getLocation() {
      this.loadingTable = true
      if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(this.calBranchDistance);
      } else {
          this.loadingTable = false
      }
    },
    async calBranchDistance(position) {
      let latitude = position.coords.latitude
      let longitude = position.coords.longitude
      this.branchList.forEach(item => {
          let distance = this.calcCrow(latitude,longitude, item.latitude,item.longitude)
          item.distance = distance 
      });
      await this.branchList.sort((a, b) => a.distance - b.distance )
      this.branchList = await this.sortCloseBranch(this.branchList)
      this.loadingTable = false
    },
    calcCrow(lat1, lon1, lat2, lon2){
      let R = 6371; // km
      let dLat = this.toRad(lat2-lat1);
      let dLon = this.toRad(lon2-lon1);
      let latitude1 = this.toRad(lat1);
      let latitude2 = this.toRad(lat2);

      let a = Math.sin(dLat/2) * Math.sin(dLat/2) +
          Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(latitude1) * Math.cos(latitude2); 
      let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
      let d = R * c;
      return d;
    },
    toRad(Value) 
    {
      return Value * Math.PI / 180;
    },
    async sortBranchByname(branchList){
      this.loadingTable = true
      let th = [] , en = []
      branchList.forEach(item => {
        if(/^([a-zA-Z])/.test(item.branchName)) en.push(item)
        else th.push(item)
      });
      th.sort(function (a, b) {
        if (a.branchName < b.branchName) return -1;
        if (a.branchName > b.branchName) return 1;
        return 0;
      });
      en.sort(function (a, b) {
        if (a.branchName < b.branchName) return -1;
        if (a.branchName > b.branchName) return 1;
        return 0;
      });
      this.loadingTable = false

      return await this.sortCloseBranch([...th,...en])
    },
    sortCloseBranch(data){
      let active= [], close =[]
      data.forEach(item => {
        if(item.disabledFlag) close.push(item)
        else active.push(item)
      });
      return [...active,...close]
    }
  }
};
</script>

<style scoped>

.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.flex{
  display: flex;
  align-items: center;
}

.crm-header-container {
    background-image: url("../../assets/svg/background.svg?inline");
    background-repeat: no-repeat;
    background-color: var(--primary);
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    min-height: 100vh;
    padding: 24px;
}

.crm-body-container{
    background-color: #ffffff;
    box-shadow: 0px 0px 30px rgba(34, 34, 34, 0.08);
    border-radius: 16px;
    padding: 24px 24px 0px;
    margin-top: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.text-left{
    text-align: left;
    width: 100%;
}
.flex-column-center{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.flex-column{
    display: flex;
    flex-direction: column;
}
.mtb-16{
    margin: 16px 0;
}
.img-location{
    width: 160px;
    height: 160px;
    margin-bottom: 12px;
}
/* text */
.branch-label{
    font-weight: 700;
    font-size: 24px;
    color: #333333;
}
.restaurant-label {
    text-align: center;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
}
.result-search{
    font-family: 'DB Heavent';
    font-weight: 400;
    font-size: 16px;
    color: #4F4F4F;
}
.name-label{
    color: #333333;
    font-weight: 400;
    font-size: 20px;

}
.location-label{
    color: #4F4F4F;
    font-weight: 400;
    font-size: 16px;
}
.table-name-text {
    font-weight: 500;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    white-space: initial;
    word-break: keep-all;
}
/* button */
.btn-crm{
    padding: 0;
    border: 1px solid #28B7FF;
    border-radius: 10px;
    background-color: #28B7FF;
    color: #fff;
    width: 100%;
    height: 40px;
    font-weight: 700;
    font-size: 20px;
    font-family: 'DB Heavent';
    margin-top: 24px;
}
.btn-crm-write{
    padding: 0;
    border: 1px solid #28B7FF;
    border-radius: 10px;
    background-color: #ffffff;
    color: #28B7FF !important;
    width: 100%;
    height: 40px;
    font-weight: 700;
    font-size: 20px;
    font-family: 'DB Heavent';
}
.el-button.is-circle.is-disabled{
    background: #DFE1E6 !important;
    border: 1px solid #DFE1E6 !important;
}
.el-button.is-circle {
    border-radius: 50% !important;
    width: 24px;
    height: 24px;
    padding: 3px;
    background: #28B7FF;
    border: 1px solid #28B7FF;
}
.el-button.el-button--default {
    color: #ffffff;
}
[class^=el-icon-]{
     font-weight: 1000 !important;
}
.el-table th.el-table__cell {
    display: none;
}
.el-table .el-table_1_column_1.el-table__cell{
  min-width: 270px;
  max-width: 280px;
}
.el-table .el-table__cell{
  max-width: 270px !important;
}
.el-table .el-table_1_column_2 .cell {
    padding-right: 0px;
}
.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
    background-color: #fff;
}
.el-button+.el-button{
    margin-left: 0px;
    margin-top: 8px;
}
.btn-crm.el-button:focus, .btn-crm.el-button:hover {
    /* color: #28B7FF !important; */
    border-color: #28B7FF;
    background-color: #28B7FF;
}
.btn-crm-write.el-button:focus, .btn-crm-write.el-button:hover {
    color: #28B7FF !important;
    border-color: #28B7FF;
    background-color: #ffffff;
}
.branch-name{
  /* width: 280px !important; */
  text-overflow: ellipsis;
}
.branch-name-disabled{
  cursor: not-allowed;
}
.branch-name-disabled .name-label, .branch-name-disabled .location-label{
  color: #A0ABAD !important;
  max-width: 200px;
}
.close-branch{
  background: #FE5F55;
  border-radius: 53px;
  color: #fff;
  height: 20px;
  padding: 0px 8px 2px;
  margin-left: 8px;
}
.el-table__body{
  width: -webkit-fill-available !important;
}
table.el-table__body {
  width: -webkit-fill-available !important;
}
</style>

